import axios from 'axios'
import helpers from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    overlay: false,
    roles: [],
    countries: [],
    cities: [],
    currency: [],
    seller: [],
    advertisingType: []
  },

  mutations: {
    SET_OVERLAY (state, payload) {
      state.overlay = payload
    },
    SET_COUNTRIES(state, payload) {
      state.countries = payload
    },
    SET_CITIES(state, payload) {
      state.cities = payload
    },
    SET_CURRENCY(state, payload) {
      state.currency = payload.data
    },
    SET_SELLER(state, payload) {
      state.seller = payload.data
    },
    SET_ADVERTISING_TYPE (state, payload) {
      state.advertisingType = payload.data
    }
  },

  getters: {
    overlay: state => state.overlay,
    countries: state => state.countries,
    cities: state => state.cities,
    currency: state => state.currency,
    seller: state => state.seller,
    seller: state => state.seller,
    advertising: state => state.advertisingType
  },

  actions: {
    async getCountry ({ commit }) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get('/api/countries')
        commit('SET_COUNTRIES', res.data)
        return res.data
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async getCities ({ commit }, id) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get(`/api/cities/${id}`)
        commit('SET_CITIES', res.data)
        return res.data
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async getCurrency ({ commit }) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get('/api/get-currencies')
        commit('SET_CURRENCY', res.data)
        return res.data
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async getSeller ({ commit }) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get('/api/get-vendors')
        commit('SET_SELLER', res.data)
        return res.data
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async getTypeAdvertising ({ commit }) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get('/api/advertising-type')
        commit('SET_ADVERTISING_TYPE', res.data)
        return res.data
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
  },
}
